import React from 'react';
import { cn } from '@/lib/utils';

interface PageHeaderProps {
  title:      string;
  /** Optional pill rendered next to the title — e.g. "42 assets" or "17 open · 4 overdue". */
  tag?:       React.ReactNode;
  /** Right-side actions: usually buttons. */
  actions?:   React.ReactNode;
  className?: string;
}

/**
 * Page-level header: title on the left, optional pill tag, actions on the right.
 *
 * Sits ABOVE the data card / table — does not wrap them. Replaces the old
 * pattern of putting page title + actions inside CardHeader, which made the
 * whole page look like one big bordered box.
 */
export function PageHeader({ title, tag, actions, className }: PageHeaderProps) {
  return (
    <div className={cn('flex items-start sm:items-center justify-between gap-3 flex-wrap', className)}>
      <div className="flex items-center gap-3 min-w-0">
        <h2 className="text-xl font-bold tracking-tight text-ink-900 truncate">{title}</h2>
        {tag && (
          <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-[11px] font-semibold uppercase tracking-wider bg-brand-50 text-brand-700">
            {tag}
          </span>
        )}
      </div>
      {actions && (
        <div className="flex items-center gap-2 flex-wrap">{actions}</div>
      )}
    </div>
  );
}
